import ProgressList from "components/ProgressList";
import { PlaformLaunchContainer } from "./PlatformLaunch.styles";

const PlatformLaunch = () => {
  return (
    <PlaformLaunchContainer>
      <ProgressList />
    </PlaformLaunchContainer>
  );
};

export default PlatformLaunch;
